import { createReducer } from '@reduxjs/toolkit';
import { newError } from 'core/redux/actions/error/errorActions';
import { isError } from 'core/utilities/exceptionHandler/exceptionHandler';

import type { ErrorState } from './errorReducer.types';

const initialState: ErrorState = {
  error: undefined,
};

const errorReducer = createReducer(initialState, (builder) => builder

  // Ensure the error is of type Error, otherwise create a new error object and nest the error variable as a string
  .addCase(newError, (state, action) => (
    {
      ...state,
      error: isError(action.payload.error)
        ? action.payload.error
        : new Error(`Unhandled exception ${JSON.stringify(action.payload.error)}`),
    }
  )));

export default errorReducer;
